import React, { Component } from 'react'
import Moment from 'react-moment'
import { Trans } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import {
  Button,
  Checkbox,
  Divider,
  Form,
  Header,
  Icon,
  Loader,
  Menu,
  Popup,
  Segment,
  Step,
  Tab,
  Table } from 'semantic-ui-react'

import { Mutation } from 'react-apollo'

import { AuthorizationError, EventEmitter, QueryWrap } from '../error_handling'
import {
  MutationFeedActivateSftppush,
  MutationFeedDeactivateSftppush,
  MutationFeedUpdateSftppush,
  QueryAllAufschaltungen,
  //QueryFeedCheckReachability,
  QueryFeedLastActivity,
  QueryFeedLog } from '../../graphql'

import { PublicKey } from './PublicKey'
import { FeedLog } from './FeedLog'
import { StaticIps } from './StaticIps'


class SftppushContent extends Component {
  constructor (props) {
    super(props)

    const { is_activated } = this.props
    this.state = {
      is_activated: is_activated
    }
  }

  handleSftppushActivated = () => {
    const is_activated = !this.state.is_activated
    this.setState({is_activated: is_activated})
    this.props.onSftppushActivated(is_activated)
  }

  handleUrlChanged = (event) => {
    this.props.onSftppushUrlChange(event.target.value)
  }

  stripEmptySpace = (value) => {
    /* Helper function for not yet initialized sftppush parameter which include
     * just one whitespace - this needs to be stripped.
     * return a dict refering to the value and the not initialized state (fresh aufschaltung)
     */
    return (value === ' ' ? {value: '', notInitialized: true} : {value: value, notInitialized: false})
  }

  render () {
    const { is_activated } = this.state
    const { params } = this.props
    const { readOnly } = this.props

    if (readOnly) {
      return this.renderReadOnly(is_activated, params)
    }
    else {
      return this.renderEditable(is_activated, params)
    }
  }

  renderReadOnly (is_activated, params) {
    return (
      <Table basic='very'>
        <Table.Body>
          <Table.Row>
            <Table.Cell>{is_activated ? <Trans>Aktiv</Trans> : <Trans>Inaktiv</Trans>}</Table.Cell>
            <Table.Cell>
              {is_activated ? <Icon name='check' className='icon-s3push-activated' /> : <br />}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell><Trans>URL-Präfix</Trans></Table.Cell>
            <Table.Cell>{this.stripEmptySpace(params.url).value}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              SFTP Public Key{params.public_key.length > 1 ? 's': ''}
            </Table.Cell>
            <Table.Cell>
              {
                (params.public_key || []).map((pubkey) => <PublicKey value={pubkey} />)
              }
            </Table.Cell>
          </Table.Row>
          { params.static_ips ? 
            <Table.Row>
              <Table.Cell>
                <Trans i18nKey='sftppush-staticips-1'>
                  Statische Quell-IP-Adressen
                </Trans>
              </Table.Cell>
              <Table.Cell>
                <StaticIps value={params.static_ips} />
              </Table.Cell>
            </Table.Row>
            : null
          }
        </Table.Body>
      </Table>
    )
  }

  renderEditable (is_activated, params) {
    const url = this.stripEmptySpace(params.url)
    const public_keys = params.public_key
    return (
      <Form>
        <Form.Group inline widths='equal'>
          <label><Trans>Aktivieren</Trans></label>
          <Form.Field control={Checkbox} toggle checked={is_activated}
                      onChange={this.handleSftppushActivated} />
          <Popup
              trigger={<Icon name='question circle outline' />}
              size='small'
              on='click'
              hideOnScroll
              flowing
            >
            <Header as='h4'><Trans>Hilfe</Trans></Header>
              <p>
                <Trans i18nKey='sftppush-help-1'>
                  Hier finden Sie eine Beschreibung, wie Sie mittels serverless<br />
                  einen S3 Bucket anlegen und die benötigten Daten auslesen.
                </Trans>
              </p>
            <Button as={NavLink} exact to='/doc/overview#was-ist-sftppush'><Trans>Mehr</Trans>...</Button>
          </Popup>
        </Form.Group>
        <Form.Group grouped>
          <label><Trans>URL-Präfix</Trans></label>
          <Form.Input
            autoFocus
            onFocus={(event) => event.target.select()}
            placeholder='sftp://user@hostname_or_ip/path'
            value={url.value}
            error={(url.notInitialized ? false : !url.value)}
            disabled={!is_activated}
            onChange={this.handleUrlChanged} />
        </Form.Group>
        <Form.Group grouped>
          <label>SFTP Public Key{public_keys.length > 1 ? 's': ''}</label>
          <p>
            {
              (public_keys || []).map((pubkey) => <PublicKey value={pubkey} />)
            }
          </p>
        </Form.Group>
        { params.static_ips ? 
          <Form.Group grouped>
            <label>
              <Trans i18nKey='sftppush-staticips-1'>
                Statische Quell-IP-Adressen
              </Trans>
            </label>
            <StaticIps value={params.static_ips} />
          </Form.Group>
          : null
        }
      </Form>
    )
  }
}

class IntroStep extends Component {
  constructor (props) {
    super(props)
  }

  render () {
    const { params } = this.props
    return (
      <div className='s3push-step1'>
        <p>
          <Trans i18nKey='sftppush-intro-1'>
            Um Meldungen per sftppush-API zu empfangen, müssen Sie einen SFTP-Server mit geeigneten
            Zugriffsrechten zur Verfügung stellen.
          </Trans>
        </p>
        <p>
          <Trans i18nKey='sftppush-intro-2'>
            Bitte richten Sie auf dem SFTP-Server einen dedizierten User ein für folgenden Public Key:
          </Trans>
        </p>
        <p>
          {
            (params.public_key || []).map((pubkey) => <PublicKey value={pubkey} is_open={true} />)
          }
        </p>
        { params.static_ips ? 
          <div>
            <p>
              <Trans i18nKey='sftppush-intro-3'>
                Folgende statische Quell-IP-Adressen stehen zur Verfügung. Bitte verwenden Sie diese für Ihre Firewall-Konfiguration:
              </Trans>
            </p>
            <StaticIps value={params.static_ips} />
          </div>
          : null
        }
      </div>
    )
  }
}

const DeliveryStep = (props) => {
  return (
    <div>
      <p>
        <Trans i18nKey='sftppush-delivery-1'>
          Die sftppush-API konnte erfolgreich eingerichtet werden.
          Ein initialer Artikelbestand wird in Kürze übertragen.
        </Trans>
      </p>
      <p>
        <Trans i18nKey='sftppush-delivery-2'>
          Klicken Sie auf <strong>"Fertig"</strong> stellen, um den Assistenten zu
          verlassen und die Installation abzuschließen.
        </Trans>
      </p>
    </div>
  )
}

class LastDelivery extends Component {

  render () {
    const { aufschaltung_id, feed_id, lang } = this.props
    const vars = {
      auid: aufschaltung_id,
      feed_id: feed_id
    }

    return (
      <QueryWrap query={QueryFeedLastActivity} variables={vars} pollInterval={30000}>
        {({ loading, error, data }) => {
          if (loading) return (<Loader active inline='centered' />)
          if (error) return `Error!: ${error}`

          const last = data.getFeedLastActivity
          return (
            <div>
            { last ? (
              <div className='last-delivery'>
                <Trans>Letzte Belieferung</Trans>:&nbsp;
                <Moment interval={10000} fromNow locale={lang}>{last}</Moment>
              </div>
              ) : null
            }
            </div>
          )
        }}
      </QueryWrap>
    )
  }
}

const overviewTabs = [
  { title: 'Log', component: FeedLog },
  //{ title: 'Erreichbarkeit', component: TestStep }
]

class StatusOverview extends Component {

  render () {
    const {
      aufschaltung_id,
      feed_id,
      pollAfterFinish,
      onStopPollAfterFinish } = this.props
    const vars = {
      auid: aufschaltung_id,
      feed_id: feed_id,
      pollAfterFinish: pollAfterFinish,
      onStopPollAfterFinish: onStopPollAfterFinish
    }

    return (
      <Tab menu={{ secondary: true, pointing: true }}
        panes={overviewTabs.map((entry, index) => {
          const Component = entry.component
          return {
            menuItem: (
              <Menu.Item key={entry.title}>
                <Trans>
                  {entry.title}
                </Trans>
              </Menu.Item>
            ),
            render: () => {
              return (
                <Tab.Pane>
                  <Component key={index} {...vars} />
                </Tab.Pane>
              )
            }
          }
        })
      } />
    )
  }
}


class ChangeSftppushSettingsButton extends Component {

  render () {
    const { style } = this.props
    const {
      aufschaltung_id,
      feed_id,
      //feedCheckReachable,
      init_is_activated,  // original value when entering edit mode
      has_params_changed,  // whether parameters have changed
      is_activated,
      params } = this.props
    const vars = {
      auid: aufschaltung_id,
      feed_id: feed_id,
      params: { url: params.url }
    }
    const refetchLogVars = {
      auid: aufschaltung_id,
      feed_id: feed_id,
      with_preview_url: true
    }

    if (!init_is_activated && is_activated) {
      // Only activate if reachability was successful!!!
      return this.render_activate_only(style, vars, refetchLogVars)
    } else if (is_activated) {
      // Only update if reachability was successful!!!
      return this.render_udpate_only(style, vars, refetchLogVars)
    } else if (has_params_changed) {
      // Deactivate and update s3-push settings
      return this.render_update_and_deactivate_only(style, vars)
    } else if (!is_activated) {
      // Only deactivate
      return this.render_deactivate_only(style, vars)
    } else return null
  }

  _render_mutation_button (style, vars, mutation, startTimer=true) {
    return (
      <Button
        style={style}
        icon
        size='mini'
        labelPosition='left'
        onClick={async () => {
          await this.props.onFinish(startTimer)
          await mutation({ variables: vars })
        }}>
        <Trans>Fertig</Trans>
        <Icon name='check' />
      </Button>
    )
  }

  render_activate_only (style, vars, refetchLogVars) {
    return (
      <Mutation mutation={MutationFeedActivateSftppush}
        awaitRefetchQueries={true}
        refetchQueries={[{query: QueryAllAufschaltungen},
                         {query: QueryFeedLog, variables: refetchLogVars}]}>
        {(feedActivateSftppush, {loading, error}) => {
          if (loading) return null
          if (error) return `Error ${error}`

          return this._render_mutation_button(style, vars, feedActivateSftppush)
        }}
      </Mutation>
    )
  }

  render_udpate_only (style, vars, refetchLogVars) {
    return (
      <Mutation mutation={MutationFeedUpdateSftppush}
        awaitRefetchQueries={true}
        refetchQueries={[{query: QueryAllAufschaltungen},
                         {query: QueryFeedLog, variables: refetchLogVars}]}>
        {(feedUpdateSftppush, {loading, error}) => {
          if (loading) return null
          if (error) return `Error ${error}`

          return this._render_mutation_button(style, vars, feedUpdateSftppush)
        }}
      </Mutation>
    )
  }

  render_deactivate_only (style, vars) {
    return (
      <Mutation mutation={MutationFeedDeactivateSftppush}
        awaitRefetchQueries={true}
        refetchQueries={[{query: QueryAllAufschaltungen}]}>
        {(feedDeactivateSftppush, {loading, error}) => {
          if (loading) return null
          if (error) return `Error ${error}`

          return this._render_mutation_button(
            style, vars, feedDeactivateSftppush, false)
        }}
      </Mutation>
    )
  }

  render_update_and_deactivate_only (style, vars) {
    return (
      <Mutation mutation={MutationFeedUpdateSftppush}>
        {(feedUpdateSftppush, {loading: loading1, error: error1}) => {
          return (
            <Mutation mutation={MutationFeedDeactivateSftppush}
              awaitRefetchQueries={true}
              refetchQueries={[{query: QueryAllAufschaltungen}]}>
            {(feedDeactivateSftppush, {loading: loading2, error: error2}) => {
              if (loading1 || loading2) return null
              if (error1 || error2) return `Error ${error1} ${error2}`

              return (
                <Button
                  style={style}
                  size='mini'
                  icon
                  labelPosition='left'
                  onClick={async () => {
                    await this.props.onFinish()
                    await feedUpdateSftppush({ variables: vars })
                    await feedDeactivateSftppush({ variables: vars })
                  }}>
                  <Trans>Fertig</Trans>
                  <Icon name='check' />
                </Button>
              )
            }}
          </Mutation>
          )
        }}
      </Mutation>
    )
  }
}

const steps = [
  {name: 'Lokale Installation', component: IntroStep},
  {name: 'Einrichten', component: SftppushContent},
  //{name: 'Erreichbarkeit Testen', component: TestStep},
  {name: 'Belieferung', component: DeliveryStep}
]

const sftpStatus = {
  INACTIVE: 0, // Parameterized and inactive
  ACTIVE: 1, // Parameterized and active
  INPROGRESS: 2,
  NOTINITIALIZED: 3 // New User/Aufschaltung
}

class SftppushOverview extends Component {
  constructor (props) {
    super(props)
    this.state = this.getState(props)
  }

  getState = (props) => {
    /**
     * Return state depending on incoming props
     */
    const { feed } = props
    const transfer_params = feed.transfer_params

    const status = this.getStatus(
      feed.is_activated,
      transfer_params.url
    )

    // Go to parameter step whenever sftppush already activated
    const stepState = (feed.is_activated ? 1 : 0)

    return {
      is_activated: feed.is_activated,
      url: transfer_params.url,
      public_key: transfer_params.public_key,
      static_ips: transfer_params.static_ips,
      init_is_activated: feed.is_activated, // need to be stored for cancel
      init_sftppush_url: transfer_params.url, // need to be stored for cancel
      status: status,
      showCancelBtn: true,
      showPreviousBtn: false,
      showNextBtn: this.nextBtnVisibile(stepState, feed.is_activated),
      showFinishBtn: this.finishBtnVisibile(stepState, feed.is_activated),
      stepState: stepState,
      feedCheckReachable: false,
      lang: props.lang,
      pollAfterFinish: false,
      timerId: null,
      timerCount: 0
    }
  }

  componentWillReceiveProps(nextProps) {
    // Update state whenever properties changed
    this.setState(this.getState(nextProps))
  }

  componentDidCatch (error) {
    // Make sure to signalize error to parent components whenever token expired (401)
    if (error.errorName === AuthorizationError.errorName) {
      EventEmitter.emit('signalError', { error: error })
    }
  }

  handleSftppushActivated = (activated) => {
    const { stepState } = this.state
    this.setState({
      is_activated: activated,
      showNextBtn: this.nextBtnVisibile(stepState, activated),
      showFinishBtn: this.finishBtnVisibile(stepState, activated)
    })
  }

  handleChangeUrl = (value) => {
    this.setState({url: value})
  }

  handleEditSftppush = () => {
    const {is_activated, url} = this.state
    if (this.hasMissingSftppushParams(is_activated, url)) {
      // Set initial state to activated
      this.setState({
        is_activated: true,
        showNextBtn: true,
        showFinishBtn: false
      })
    }
    this.setState({ status: sftpStatus.INPROGRESS })
  }

  /*
  handleFeedCheckReachability = (ok) => {
    if (this.state.feedCheckReachable === ok) return
    this.setState({feedCheckReachable: ok})
  }*/

  hasMissingSftppushParams = (is_activated, url, checkAll=true) => {
    const hasUrl = (url && url !== '' && url !== ' ')
    if (checkAll) {
      // All parameters are not set properly yet
      return (!hasUrl  && !is_activated)
    }
    return (!hasUrl || !is_activated)
  }

  nextBtnVisibile = (stepState, is_activated) => {
    /* Return whether the next button is visible or not - which depends on the
     * parameter is_activated
     */
    return ((stepState === 0 || is_activated) ? true : false)
  }

  finishBtnVisibile = (stepState, is_activated) => {
    /* Return whether the finish button is visible or not - which depends on the
     * parameter is_activated
     */
    return ((stepState === 0 || is_activated) ? false : true)
  }

  getStatus = (is_activated, url) => {
    if (this.hasMissingSftppushParams(is_activated, url)) {
      return sftpStatus.NOTINITIALIZED
    }
    return (is_activated ? sftpStatus.ACTIVE : sftpStatus.INACTIVE)
  }

  setNavState = (next) => {
    if (next < steps.length) {
      this.setState({ stepState: next })
    }

    let btnState = undefined
    if (next > 0 && next < steps.length - 1) {
      btnState = {
        showCancelBtn: false,
        showPreviousBtn: true,
        showNextBtn: true,
        showFinishBtn: false
      }
    } else if (next === 0) {
      btnState = {
        showCancelBtn: true,
        showPreviousBtn: false,
        showNextBtn: true,
        showFinishBtn: false
      }
    } else {
      btnState = {
        showCancelBtn: false,
        showPreviousBtn: true,
        showNextBtn: false,
        showFinishBtn: true
      }
    }
    this.setState(btnState)
  }

  next = () => {
    const { stepState } = this.state
    if (stepState === 1) {
      // Trim leading and trailing spaces of parameters before reachability
      // test comes up
      const { url } = this.state
      this.setState({
        url: url.trim()
      })
    }
    this.setNavState(stepState + 1)
  }

  previous = () => {
    if (this.state.stepState > 0) {
      this.setNavState(this.state.stepState - 1)
    }
  }

  cancel = () => {
    // Reset to inital values
    const { init_is_activated, init_sftppush_url } = this.state
    this.setState({
      is_activated: init_is_activated,
      url: init_sftppush_url,
      status: this.getStatus(
        init_is_activated,
        init_sftppush_url),
      showCancelBtn: true,
      showPreviousBtn: false,
      showNextBtn: true,
      showFinishBtn: false,
      stepState: 0
    })
  }

  finish = (startTimer=false) => {
    const {
      stepState,
      is_activated,
      url } = this.state
    this.setState({
      status: this.getStatus(is_activated, url),
      showPreviousBtn: false,
      showNextBtn: this.nextBtnVisibile(stepState, is_activated),
      showFinishBtn: this.finishBtnVisibile(stepState, is_activated),
      stepState: 0
    })
    if (startTimer) {
      // Only start timer if needed
      this.startTimer()
    }
  }

  startTimer = () => {
    const { pollAfterFinish } = this.state
    if (!pollAfterFinish) {
      this.setState({pollAfterFinish: true})
      this.timedCount()
    }
  }

  timedCount = () => {
    const { pollAfterFinish, timerCount } = this.state
    if (pollAfterFinish) {
      this.setState({timerId: setTimeout(this.timedCount, 1000), timerCount: timerCount + 1})
      if (timerCount === 60) {
        // Stop after 1min
        this.stopTimer()
      }
    }
  }

  stopTimer = () => {
    const { timerId } = this.state
    clearTimeout(timerId)
    this.setState({pollAfterFinish: false})
  }

  render () {
    const { status } = this.state
    switch (status) {
      case sftpStatus.NOTINITIALIZED:
        return this.renderInitial()
      case sftpStatus.INACTIVE:
        return this.renderInactive()
      case sftpStatus.ACTIVE:
        return this.renderActive()
      case sftpStatus.INPROGRESS:
        return this.renderInProgress()
      default:
        return null
    }
  }

  renderInitial () {
    const { feed, userInfo } = this.props
    const nickname = feed.nickname
    const userVerified = userInfo && userInfo.email_verified

    const is_feed_activation_disabled = feed.is_activation_disabled
    const last_activation_change_reason = feed.last_activation_change_reason

    let reason
    if (!userVerified) {
      reason = <Trans i18nKey="sftppush-unverified" nickname={nickname}>Ihr Feed der sftppush-API «{{nickname}}» kann erst aktiviert werden, wenn Sie Ihre E-Mail-Adresse (siehe Registrierungs-Mail) bestätigt haben.</Trans> 
    } else if (is_feed_activation_disabled) {
      reason = last_activation_change_reason === 'soft-expired' ?
      <Trans i18nKey="sftppush-auto-expire" nickname={nickname}>Ihr Feed der sftppush-API «{{nickname}}» wurde automatisch deaktiviert. Klicken Sie auf "sftppush-API Einrichten", um den Feed zu aktivieren.</Trans> :
      <Trans i18nKey="sftppush-expired" nickname={nickname}>Ihr Feed der sftppush-API «{{nickname}}» ist leider abgelaufen. <br />
      Kontaktieren Sie bitte unseren <NavLink exact to='/contact'>Kundenservice</NavLink>, wenn Sie an einer weiteren Belieferung interessiert sind.</Trans>
    }

    const is_activation_disabled = is_feed_activation_disabled || !userVerified
    const btn_disabled = (is_feed_activation_disabled &&
      last_activation_change_reason !== 'soft-expired') || !userVerified

    return (
      <div>
        { is_activation_disabled ? 
          <p>
            {reason}
          </p>
          :
          <p>
            <Trans i18nKey='sftppush-not-yet-installed-api-1' nickname={nickname}>
              sftppush für «{{nickname}}» noch nicht eingerichtet.
              Klicken Sie auf "sftppush-API Einrichten", um den Feed zu aktivieren.
            </Trans>
          </p>
        }
        <p>
          <Trans i18nKey='sftppush-initial-2'>
            Was ist die sftppush-API? Informieren Sie sich im <NavLink exact to='/doc/overview#was-ist-die-sftppush-api'>Bereich der Dokumentation</NavLink>.
          </Trans>
        </p>
        <Divider />
        <Button icon='add' size='mini' floated='left'
          disabled={btn_disabled}
          onClick={this.handleEditSftppush}>
          <Trans>sftppush-API Einrichten</Trans>
        </Button>
      </div>
    )
  }

  renderInactive () {
    return (
      <div>
        <p>
          <Trans>Deaktiviert</Trans>.
        </p>
        <p>
          <Trans i18nKey='sftppush-initial-2'>
            Was ist die sftppush-API? Informieren Sie sich im <NavLink exact to='/doc/overview#was-ist-die-sftppush-api'>Bereich der Dokumentation</NavLink>.
          </Trans>
        </p>
        <Divider />
        <Button icon='add' size='mini' floated='left' onClick={this.handleEditSftppush}>
          <Trans>sftppush-API Einrichten</Trans>
        </Button>
      </div>
    )
  }

  renderActive () {
    const { aufschaltung_id, feed } = this.props
    const { is_activated, url, public_key, static_ips } = this.state

    const { lang } = this.state
    const params = {
      url: url,
      public_key: public_key,
      static_ips: static_ips
    }
    const sftppush_params = {
      is_activated: is_activated,
      params: params,
      onSftppushActivated: this.handleSftppushActivated,
      onSftppushUrlChange: this.handleChangeUrl
    }

    return (
      <div>
        <div className='s3push-table-and-edit'>
          <div className='s3push-table'><SftppushContent {...sftppush_params} readOnly={true} /></div>

          <div><Button 
                content={<Trans>Editieren</Trans>}
                size='mini'
                onClick={this.handleEditSftppush} /></div>
        </div>
        <LastDelivery
          aufschaltung_id={aufschaltung_id}
          feed_id={feed.id}
          lang={lang} />

        <StatusOverview aufschaltung_id={aufschaltung_id} feed_id={feed.id}
          pollAfterFinish={this.state.pollAfterFinish}
          onStopPollAfterFinish={this.stopTimer}/>
      </div>
    )
  }

  renderInProgress () {
    const { aufschaltung_id, feed } = this.props
    const {
      stepState,
      //feedCheckReachable,
      init_is_activated,
      init_sftppush_url,
      is_activated,
      url,
      public_key,
      static_ips
    } = this.state

    // Check whether the actual parameters have changed in this context
    const hasParamsChanged = (
      init_sftppush_url !== url
    )

    const params = {
      url: url,
      public_key: public_key,
      static_ips: static_ips
    }

    const StepComponent = steps[stepState].component
    const stepProps = {
      auid: aufschaltung_id,
      feed_id: feed.id,
      is_activated: is_activated,
      params: params,
      onSftppushActivated: this.handleSftppushActivated,
      onSftppushUrlChange: this.handleChangeUrl,
      //onS3PushFeedCheckReachability: this.handleFeedCheckReachability,
      //feedCheckReachable: feedCheckReachable,
      readOnly: false}

    return (
      <div>
        {this.renderSteps()}
        <Segment style={{'min-height': '280px'}} className='stepping'>
          {<StepComponent {...stepProps} />}
        </Segment>
        <div>
          <Button
            style={this.state.showCancelBtn ? {width: '150px'} : { display: 'none' }}
            icon
            size='mini'
            labelPosition='left'
            onClick={this.cancel}>
            <Icon name='cancel' />
            <Trans>Abbrechen</Trans>
          </Button>

          <Button
            style={this.state.showPreviousBtn ? {width: '150px'} : { display: 'none' }}
            icon
            size='mini'
            labelPosition='left'
            onClick={this.previous}>
            <Icon name='left arrow' />
            <Trans>Zurück</Trans>
          </Button>

          <Button
            style={this.state.showNextBtn ? {width: '150px'} : { display: 'none' }}
            icon
            size='mini'
            disabled={
              (stepState === 0 ? false
                : this.hasMissingSftppushParams(is_activated, url, false))
            }
            labelPosition='right'
            onClick={this.next}>
            <Trans>Weiter</Trans>
            <Icon name='right arrow' />
          </Button>

          <ChangeSftppushSettingsButton
            style={this.state.showFinishBtn ? {width: '150px'} : { display: 'none' }}
            aufschaltung_id={aufschaltung_id}
            feed_id={feed.id}
            init_is_activated={init_is_activated}
            has_params_changed={hasParamsChanged}
            is_activated={is_activated}
            params={params}
            onFinish={this.finish} />
        </div>
      </div>
    )
  }

  renderSteps () {
    const { is_activated } = this.state

    return (
      <Step.Group size='mini' widths={steps.length}>
        { steps.map((s, index) => {
          const showIcon = (this.state.stepState === index && index === 3)
          return (
            // Hack: show icon always to have same height for each step
            <Step key={index}
              disabled={(index > 1 && !is_activated)}
              active={this.state.stepState === index}
              link onClick={() => this.setNavState(index)}>
              <Icon name={(this.state.feedCheckReachable ? 'check' : 'warning sign')}
                style={{color: (this.state.feedCheckReachable ? 'green' : 'sandybrown')}}
                className={(showIcon ? 'icon-s3push-step-show' : 'icon-s3push-step-hide')} />
              <Step.Content>
                <Step.Title><Trans>{s.name}</Trans></Step.Title>
              </Step.Content>
            </Step>
          )
        })
        }
      </Step.Group>
    )
  }
}

export default SftppushOverview


// WEBPACK FOOTER //
// ./src/components/push_apis/SftppushOverview.js